'use strict';

require('./partials/carouselStrip.js');
require('./partials/carouselSlide.js');
require('./partials/carouselCounter.js');
const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:carousel');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * @class
     * PhoenixCarousel
     *
     * @classdesc The carousel web component for cycling throught child carousel slides
     *
     * @example
     *      <phoenix-carousel id="test123" total-slides="3">
     *          <phoenix-carousel-counter
     *              separator="of">1 of 3</phoenix-carousel-counter>
     *          <phoenix-notifier event-name="phoenix:carousel:previous">
     *              <button aria-label="previous">previous</button>
     *          </phoenix-notifier>
     *          <phoenix-notifier event-name="phoenix:carousel:next">
     *              <button aria-label="next">next</button>
     *          </phoenix-notifier>
     *          <phoenix-carousel-slide
     *              slide-id="slide-test123-1"
     *              aria-hidden="false">Slide 1</phoenix-carousel-slide>
     *          <phoenix-carousel-slide
     *              slide-id="slide-test123-2"
     *              aria-hidden="true" hidden>Slide 2</phoenix-carousel-slide>
     *          <phoenix-carousel-slide
     *              slide-id="slide-test123-3"
     *              aria-hidden="true" hidden>Slide 3</phoenix-carousel-slide>
     *      </phoenix-carousel>
     */

    class PhoenixCarousel extends pageClass.PhoenixElement {
        /**
         * Defines what custom emitted events will be observed.
         *
         * @return {Array} Array of strings containing custom event names
         * to observe
         */
        get observedEmittedEvents() {
            return ['phoenix:carousel:previous', 'phoenix:carousel:next'];
        }

        get slides() {
            if (!this._slides) {
                this._slides = this.querySelectorAll('phoenix-carousel-slide');
            }
            return this._slides;
        }

        get slideIds() {
            if (this._slideIds === undefined) {
                let _slideIds = this.slides;
                let slides = [..._slideIds].map((el) => el.getAttr('slide-id'));
                this._slideIds = [...new Set(slides)];
            }

            return this._slideIds;
        }

        connectedCallback() {
            super.connectedCallback();
            this._currentSlideIndex = 0;
        }

        /**
         * Detects when any of the observed event is emmitted
         *
         * @param  {String} name Name of the custom event
         * @param  {Object} args Custom event properties
         */
        emittedEventCallback(name, args = {}) {
            let currentSlide = this._currentSlideIndex;
            switch (name) {
                case 'phoenix:carousel:previous':
                    this._currentSlideIndex =
                        currentSlide === 0 ? this.slideIds.length - 1 : currentSlide - 1;
                    break;
                case 'phoenix:carousel:next':
                    this._currentSlideIndex =
                        currentSlide === this.slideIds.length - 1 ? 0 : currentSlide + 1;
                    break;
            }
            this.notify();
        }

        notify() {
            const eventKey = 'phoenix:carousel:activeSlide';
            this.emitEvent(eventKey, {
                bubbles: true,
                detail: {
                    key: eventKey,
                    value: this._currentSlideIndex,
                    slide: this.slideIds[this._currentSlideIndex],
                },
            });
        }
    }
    window.customElements.define('phoenix-carousel', PhoenixCarousel);
    measure.end();
});
